import { useState } from "react";
import { UIButton, UICard, UIChip, UIStack, UITypography } from "../../../_app/components";
import { createStylesheet } from "../../../_app/utils/styles";
import { CheckCircle as CheckIcon } from "../../../_app/components/icons";
import EnableMFADialog from "./EnableMFADialog";
import DisableMFADialog from "./DisableMFADialog";
import { useMfaEnabled } from "../../../auth/hooks";

export const MFAToggle = () => {
  const classes = useStyles();
  const { data: hasMfaEnabled } = useMfaEnabled();
  const [mfaAttemptEnable, setMfaAttemptEnable] = useState(false);
  const [mfaAttemptDisable, setMfaAttemptDisable] = useState(false);

  const toggleMfaState = () => {
    if (!hasMfaEnabled) setMfaAttemptEnable(true);
    else setMfaAttemptDisable(true);
  };

  const renderDescriptionText = () => {
    if (!hasMfaEnabled) {
      return "Add an extra layer of security to your account by enabling Multi-Factor Authentication. Once enabled, you'll need to verify your identity using an authenticator app when logging in.\n\nWe support Google Authenticator, Microsoft Authenticator, Authy, and other apps.";
    }
    return "Turning off MFA will remove the extra security layer from your account. You will no longer need to verify your identity with an authenticator app when logging in.";
  };

  return (
    <UICard elevation={1} className={classes.ctr}>
      <UIStack alignItems="flex-start" spacing={3}>
        <UITypography variant="h4">{hasMfaEnabled ? "Disable" : "Enable"} Multi-Factor Authentication (MFA)</UITypography>
        {hasMfaEnabled && (
          <UIChip variant="outlined" color="success" label="You have MFA enabled" size="medium" icon={<CheckIcon />} />
        )}
        <UITypography>{renderDescriptionText()}</UITypography>
        <UIButton data-cy="toggle-mfa-btn" variant="contained" onClick={toggleMfaState}>
          {hasMfaEnabled ? "Disable" : "Enable"} MFA
        </UIButton>
        {hasMfaEnabled ? (
          <DisableMFADialog open={mfaAttemptDisable} onClose={() => setMfaAttemptDisable(false)} />
        ) : (
          <EnableMFADialog open={mfaAttemptEnable} onClose={() => setMfaAttemptEnable(false)} />
        )}
      </UIStack>
    </UICard>
  );
};

const useStyles = createStylesheet((theme) => ({
  ctr: {
    padding: theme.spacing(4),
    whiteSpace: "pre-wrap",
  },
  verifyField: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    padding: 0,
  },
}));

export default MFAToggle;
